import React from "react";
import { FormFieldWrapper } from "../../../../components/private";
import { Row } from "antd";
import { Input } from "formik-antd";
import { useLocale } from "../../../../hooks";

const { TextArea } = Input;

const BodyField = React.memo(() => {
  const t = useLocale("posts/form");

  return (
    <Row justify="start" align="middle" gutter={[48, 0]}>
      <FormFieldWrapper
        name="body"
        placeholder={t("fields.body.placeholder")}
        multiLine
      >
        <TextArea name="body"></TextArea>
      </FormFieldWrapper>
    </Row>
  );
});

export default BodyField;
